import React, { useState, useEffect } from 'react';
import i18next from 'i18next';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { setPortal } from 'modules/portal';
import { epApiData } from 'lib/api/sales';

import FilterWrap from 'components/atoms/FilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import TableContainer from 'components/molecules/MbTable';
import MbSelectbox from 'components/molecules/MbSelectbox';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

const hostingFilterList = [
  { CODE_ID: '00', CODE_DESC: i18next.t('전체') },
  { CODE_ID: '01', CODE_DESC: 'Makeshop' },
  { CODE_ID: '02', CODE_DESC: 'Cafe24' },
  { CODE_ID: '03', CODE_DESC: 'GodoMall' },
];
const tableInfoMessage = (
  <p>
    광고주별 상품API 정산 내역 데이터로, API연동 기능을 신청한 광고주만
    노출됩니다.
    <br />※ 카페24/고도몰:
    배너(해비쇼퍼)+배너(관심상품)+배너(본상품)+배너(프로모션)+배너(보완재)
  </p>
);

let initialization = false;
let initParam = {
  statsMth: moment().add(-1, 'month').format('YYYYMM'),
  hosting: '00',
};

const EpApiCalculate = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  // 공통 필터에서 초기값 받아왔는지 확인
  const [params, setParams] = useState(initParam);
  const [getInitParam, setGetInitParam] = useState(false);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const customized = {
    CALCULATE_DATE: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'CALCULATE_DATE').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const sDate = moment()
          .startOf('month')
          .add(-1, 'month')
          .format('YYYYMMDD');
        const eDate = moment()
          .endOf('month')
          .add(-1, 'month')
          .format('YYYYMMDD');
        const calculateDate = getHeadObj(headsMap, 'CALCULATE_DATE');
        const showWindowUrl =
          '/sales/revenue/epApiDetail?sDate=' +
          sDate +
          '&adverId=' +
          rowObj['ADVER_ID'] +
          '&pname=' +
          rowObj['PNAME'] +
          '&hostingName=' +
          rowObj['HOSTING_NAME'] +
          '&corpName=' +
          rowObj['CORP_NAME'] +
          '&eDate=' +
          eDate +
          '&uri=/sales/revenue/epApiDetail&isPop=1';

        let resultComponent = (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['CALCULATE_DATE'],
              calculateDate.type,
              calculateDate.format
            )}
            icon={
              rowObj['HOSTING_NAME'] !== 'total' &&
              !rowObj.isChild &&
              rowObj.CORP_NAME !== 'total' &&
              'link'
            }
            toolTipTitle={t('해당 지면의 일자별 통계 new 팝업')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );

        return resultComponent;
      },
      headStyle: {
        width: 110,
      },
    },
    CALCULATE_AMT: {
      makeBody: (rowObj) => {
        return <>{makeRowColumn(rowObj['CALCULATE_AMT'])}</>;
      },
      bodyStyle: {
        textAlign: 'center',
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const handleOnchangeSelectHostingParams = (no, index) => {
    const newParams = {
      ...params,
      hosting: hostingFilterList[index].CODE_ID,
    };
    setParams(newParams);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          initData={initParam}
          dateId={'statsMth'}
          noneDate
          useSingleDate
          useMonthDate
          noneExternalFilter
          nonePltfomTpCodeFilter
          noneDisplayFilter
        />
        <MbSelectbox
          key="hosting"
          label={t('호스팅사')}
          value={params.hosting}
          itemindex={params.hosting !== '00' && params.hosting}
          name="hosting"
          optionData={hostingFilterList}
          optionLabelKey="CODE_DESC"
          optionValueKey="CODE_ID"
          handleOnchange={handleOnchangeSelectHostingParams}
          icon={false}
        />
      </FilterWrap>
      <>
        <TableContainer
          dataReqPromise={epApiData}
          params={{ ...params }}
          sort="desc"
          order="ADVRTS_AMT"
          dense={true}
          customized={customized}
          hasExcel
          hasTotal
          toolTip={tableInfoMessage}
        />
      </>
    </>
  );
};

export default EpApiCalculate;
